/** i18n del módulo CRONJOBS (inglés) */
export default {
  cronjobs: {
    title: "Scheduled tasks (CRON)",
    subtitle:
      "Set how often each server job runs. Requires the CRONJOBS module to be active.",
    timezone: "Timezone",
    timezoneHelp: "Applies to all jobs on this screen.",
    timezoneSaveHint:
      'The timezone is saved when you click "Save this job" on any job.',
    jobEnabled: "Enabled",
    frequency: "Frequency",
    frequencyHourly: "Every hour (at minute 0)",
    frequencyEvery6h: "Every 6 hours",
    frequencyDaily: "Once per day",
    frequencyWeeklyMon: "Every Monday",
    frequencyCustom: "Custom cron expression",
    dailyAtHour: "Time of day (0–23)",
    cronExpression: "Cron expression",
    cronHelp:
      "Format: minute hour day-of-month month day-of-week (e.g. 0 3 * * * = daily at 03:00). The server schedules one run per occurrence (cron-parser + timer).",
    cronExpressionManualHelp:
      "Type any valid expression here for tests (e.g. 0 20 * * * = 20:00 every day). Editing this field switches the preset to «Custom».",
    targetDatabases: "Databases (optional)",
    targetDatabasesHelp:
      "Empty = current database only. Comma-separated for several (e.g. duntower, client1).",
    findTeuJobScopeOnlyDb:
      "This job only syncs trackings in this client’s database (your session). Each tenant stores CRON config in their own MongoDB; the server runs a separate schedule per tenant that has CRONJOBS active.",
    saveJob: "Save this job",
    runNow: "Run now",
    lastRun: "Last run",
    lastRunTitle: "Last run",
    lastRunInTimezone: "Time shown in «{tz}» (same zone used by the job scheduler).",
    lastRunManual: "Manual",
    lastRunNever: "Not run yet (neither on schedule nor via “Run now”).",
    lastRunOk: "OK",
    lastRunError: "Error",
    duration: "Duration",
    loadError: "Could not load cron configuration.",
    saveOk: "Settings saved.",
    saveError: "Could not save.",
    runOk: "Job executed.",
    runError: "Job failed to run.",
    moduleInactiveHint:
      "Enable the CRONJOBS module under System modules to use this screen.",
    backupsTitle: "Backups on server",
    backupsHint:
      "Only files for the current database ({db}) are listed. Each tenant has its own folder on disk.",
    backupsEmpty:
      "No .archive.gz files yet. Run the «Database backup» job or wait for the scheduled cron.",
    backupsLoadError: "Could not load the backup list.",
    backupFile: "File",
    backupSize: "Size",
    backupDate: "Date",
    backupDownload: "Download",
    backupDownloading: "Downloading…",
    backupDownloadTokenTitle: "Anonymous download (latest backup)",
    backupDownloadTokenHint:
      "Generate a token to download the most recent backup without signing in. Anyone with the URL can fetch the file.",
    backupDownloadTokenActive: "Active token",
    backupDownloadTokenGenerated: "Generated",
    backupDownloadTokenGenerate: "Generate token",
    backupDownloadTokenRegenerate: "Generate new token",
    backupDownloadTokenRegenerateConfirm: "The previous token will stop working.",
    backupDownloadTokenRevoke: "Revoke token",
    backupDownloadTokenRevokeConfirm: "The URL will stop working immediately.",
    backupDownloadTokenGenerateOk: "Token generated. Copy the URL now.",
    backupDownloadTokenRevokeOk: "Token revoked.",
    backupDownloadTokenError: "Could not manage the token.",
    backupDownloadUrlLabel: "Download URL",
    backupDownloadTokenOnceHint: "The full URL will not be shown again. Generating a new one invalidates the previous URL.",
    backupDownloadUrlCopied: "URL copied to clipboard.",
    backupDownloadUrlCopyError: "Could not copy the URL.",
    backupDownloadUrlCopyManual: "Select the URL in the field and copy it manually (Ctrl+C / Cmd+C).",
    nextRunTitle: "Next scheduled run",
    nextRunDisabled: "Job disabled — no countdown.",
    nextRunInvalid: "Could not compute next run (check cron expression and timezone).",
    nextRunAt: "Next run (approx.)",
    countdownLabel: "Time remaining",
    countdownImminent: "Due now",
    schedulerStatusTitle: "Scheduler in this server process",
    schedulerRunning: "Running",
    schedulerStopped: "Stopped (no cron tasks in memory)",
    schedulerReferenceDb: "Reference DB for this scheduler",
    schedulerScheduledJobs: "Scheduled job keys",
    schedulerTenantsTitle: "Tenants with scheduled jobs (this process)",
    schedulerScheduledJobsUnique: "Distinct job keys (any tenant)",
    schedulerDiscoveryMode: {
      auto:
        "Tenant list: every database on the server with CRONJOBS active (set CRONJOBS_TENANT_DATABASES on the server to restrict).",
      explicit:
        "Tenant list: CRONJOBS_TENANT_DATABASES only (each must have CRONJOBS active).",
    },
    schedulerNone: "none",
    connState: "Mongo connection",
    lastScheduledEvent: "Last scheduled tick (this process)",
    idleCloseHint:
      "Mongo may show disconnected between runs; the server reconnects when a job runs (idle connections are closed after a period without traffic).",
    activityLogTitle: "Activity log (this page)",
    activityLogHint:
      "Manual actions and detected runs (polling every 30s). Does not replace server logs.",
    activityLogClear: "Clear",
    logPageLoaded: "Page loaded.",
    logConfigLoaded: "Configuration loaded from server.",
    logJobSaved: "Job «{job}» saved.",
    logManualRunOk: "Manual run finished: «{job}» ({ms} ms).",
    logManualRunFail: "Manual run failed: «{job}».",
    logRunDetected: "New run detected for «{job}» (sync from server).",
    logScheduledHint: "Scheduled",
    logManualHint: "Manual",
    customJobsTitle: "Custom jobs (Hook automations)",
    customJobsHint: "Link these from Hook automations with a cron trigger.",
    hookAutomationsLink: "Hook automations",
    customCreate: "New custom job",
    customCreateTitle: "New custom cron job",
    customName: "Name",
    customNameRequired: "Enter a name",
    customDelete: "Delete",
    customDeleteConfirm: "Delete job «{job}»?",
    customDeleteOk: "Job deleted",
    customTypeBadge: "Custom",
  },
};
